import { Button, Spinner } from "react-bootstrap";
import styles from "./NextButton.module.scss";

interface NextButtonProps {
  onClick: () => void;
  disabled: boolean;
  isPending: boolean;
}

export default function NextButton(props: NextButtonProps) {
  return (
    <Button onClick={props.onClick} disabled={props.disabled}>
      {props.isPending ? (
        <>
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            className={styles.spinner}
          />
          Creating...
        </>
      ) : (
        "Next"
      )}
    </Button>
  );
}

